export enum ControllerNavAction {
  Dashboard = 'dashboard',
  Devices = 'devices',
  Groups = 'groups',
  Artifacts = 'artifacts',
  Projects = 'projects',
  Connectivity = 'connectivity',
  ControllerV2Link = 'controllerV2',
  Account = 'settings',
  AccountProfile = 'settings/account',
  AccountUsers = 'settings/users',
  AccountApiKeys = 'settings/apikeys',
  AccountNotifications = 'settings/notifications',
  Resources = 'resources',
  ResourcesQuickstart = 'https://docs.bymason.com/setup-guide?utm_source=Controller&utm_medium=Referral',
  ResourcesDocs = 'https://docs.bymason.com/?utm_source=Controller&utm_medium=Referral',
  ResourcesDevKits = 'store/products',
  ResourcesByMason = 'https://bymason.com/?utm_source=Controller&utm_medium=Referral',
  ResourcesContactSupport = 'resources/contactsupport',
  Logout = 'logout',
}

export interface BaseMenuProps {
  anchorElem: HTMLDivElement | null;
  open: boolean;
  onItemClick: (action: ControllerNavAction) => void;
  onClose: () => void;
}
